__turbopack_context__.v({
  "category": "PriceTable-module-scss-module__z6PPvW__category",
  "categoryColumn": "PriceTable-module-scss-module__z6PPvW__categoryColumn",
  "chevron": "PriceTable-module-scss-module__z6PPvW__chevron",
  "columnHeaders": "PriceTable-module-scss-module__z6PPvW__columnHeaders",
  "description": "PriceTable-module-scss-module__z6PPvW__description",
  "desktopTable": "PriceTable-module-scss-module__z6PPvW__desktopTable",
  "details": "PriceTable-module-scss-module__z6PPvW__details",
  "mobileService": "PriceTable-module-scss-module__z6PPvW__mobileService",
  "mobileTable": "PriceTable-module-scss-module__z6PPvW__mobileTable",
  "priceColumn": "PriceTable-module-scss-module__z6PPvW__priceColumn",
  "prices": "PriceTable-module-scss-module__z6PPvW__prices",
  "service": "PriceTable-module-scss-module__z6PPvW__service",
  "serviceColumn": "PriceTable-module-scss-module__z6PPvW__serviceColumn",
  "serviceTitle": "PriceTable-module-scss-module__z6PPvW__serviceTitle",
  "summary": "PriceTable-module-scss-module__z6PPvW__summary",
  "summaryBar": "PriceTable-module-scss-module__z6PPvW__summaryBar",
  "summaryNotes": "PriceTable-module-scss-module__z6PPvW__summaryNotes",
  "summaryRow": "PriceTable-module-scss-module__z6PPvW__summaryRow",
  "type": "PriceTable-module-scss-module__z6PPvW__type",
  "typeColumn": "PriceTable-module-scss-module__z6PPvW__typeColumn",
  "values": "PriceTable-module-scss-module__z6PPvW__values",
  "visuallyHidden": "PriceTable-module-scss-module__z6PPvW__visuallyHidden",
  "wrapper": "PriceTable-module-scss-module__z6PPvW__wrapper",
});
